const WhatsAppIconCloud = ({ width = "18", height = "18", style, ...props }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1254.000000 1254.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)"
      fill="#49DB7F" stroke="none">
      <path d="M6080 11290 c-603 -56 -1131 -182 -1635 -390 -1300 -536 -2369 -1593
      -2913 -2880 -214 -509 -342 -1012 -414 -1630 -30 -253 -32 -837 -5 -1060 63
      -515 179 -915 384 -1325 73 -145 119 -224 220 -376 45 -69 83 -131 83 -138 0
      -25 -353 -917 -730 -1846 -78 -192 -149 -370 -157 -395 -22 -69 -13 -176 21
      -234 46 -78 131 -126 223 -126 54 0 1933 622 2103 696 125 54 318 130 486 189
      l122 43 98 -56 c208 -117 565 -271 802 -346 119 -37 417 -111 547 -135 835
      -154 1731 -88 2565 189 871 289 1626 775 2199 1415 654 730 1052 1577 1171
      2494 67 515 46 1110 -58 1611 l-28 135 -432 3 c-238 1 -432 -1 -432 -5 0 -5 9
      -46 21 -93 91 -380 119 -586 126 -920 8 -371 -13 -614 -78 -910 -72 -325 -147
      -537 -304 -855 -289 -589 -746 -1126 -1312 -1542 -781 -576 -1720 -861 -2678
      -813 -404 20 -734 78 -1109 195 -278 86 -634 242 -899 393 l-109 62 -161 -59
      c-89 -33 -261 -96 -382 -141 -121 -45 -391 -144 -600 -220 -209 -76 -460 -168
      -559 -204 -98 -37 -180 -65 -181 -64 -3 3 31 88 230 573 81 198 166 407 190
      465 23 58 90 215 147 350 58 135 108 255 112 267 6 18 -10 43 -87 135 -289
      347 -462 647 -591 1025 -237 698 -244 1542 -21 2408 171 662 484 1265 925
      1780 136 158 404 423 555 547 679 559 1445 887 2310 988 362 42 705 38 1045
      -11 396 -57 687 -146 1005 -308 72 -36 133 -66 137 -66 3 0 37 45 74 100 102
      153 219 299 322 402 52 51 92 99 89 106 -6 19 -178 120 -332 196 -389 191
      -793 310 -1245 367 -147 18 -713 27 -860 14z"/>
      <path d="M9305 10790 c-310 -40 -623 -205 -837 -442 -166 -184 -260 -364 -347
      -667 -6 -19 -20 -27 -78 -42 -181 -47 -329 -126 -472 -250 -266 -232 -421
      -570 -421 -919 0 -295 103 -558 300 -764 174 -181 380 -292 630 -337 61 -11
      329 -14 1445 -13 1246 0 1378 2 1462 17 430 80 760 364 893 768 74 226 67 518
      -16 751 -121 336 -394 608 -720 718 -115 39 -228 60 -324 60 l-77 0 -16 83
      c-104 526 -477 909 -998 1023 -87 19 -323 27 -424 14z"/>
      <path d="M4640 8211 c-113 -16 -266 -82 -382 -164 -92 -66 -237 -219 -303
      -320 -107 -165 -188 -366 -232 -577 -25 -120 -25 -383 0 -500 69 -325 258
      -679 667 -1250 246 -343 359 -478 655 -779 190 -193 345 -335 510 -468 504
      -403 1036 -666 1535 -759 134 -25 421 -30 560 -10 323 47 652 226 860 467 232
      269 255 611 53 799 -57 54 -98 77 -371 211 -367 181 -602 291 -657 309 -22 8
      -70 13 -107 13 -57 -1 -77 -7 -139 -39 -63 -33 -92 -60 -230 -210 -88 -94
      -178 -184 -201 -200 -62 -43 -135 -40 -253 12 -355 156 -781 520 -1185 1013
      -161 197 -282 389 -309 489 -23 82 -8 107 173 291 231 236 269 298 269 446 1
      93 -1 97 -128 360 -228 472 -338 685 -375 728 -98 110 -246 160 -410 138z"/>
      </g>
    </svg>
  );
};

export default WhatsAppIconCloud;
